export class Controller {

    /** @ngInject */
    constructor(AccessRequestsService, $rootScope, $state) {
        this.AccessRequestsService = AccessRequestsService;
        this.$rootScope = $rootScope;
        this.$state = $state;
    }

    $onInit() {
    }

    companyChanged() {
        this.applications = null;
        this.selectedApplication = null;
        if(this.selectedCompany != null) {
            this.AccessRequestsService.getApplications(this.selectedCompany.id)
            .then(applications => {
                this.applications = applications;
            });
        }
    }

    applicationChanged() {

    }

    saveDisabled() {
        return !(this.note && this.note.length > 0 && this.selectedCompany && this.selectedApplication);
    }

    save() {
        let requestDto = {
            companyId: this.selectedCompany.id,
            applicationId: this.selectedApplication.id,
            note: this.note
        }
        this.AccessRequestsService
            .createRequest(requestDto)
            .then(() => this.$state.go('^', {}, {reload: '^'}))
    }

	goBack() {
		var goToState = this.$rootScope.transition.from();
		var theState = goToState.name;
		if (theState === "") {
			theState = goToState.url;
		}
		this.$state.go(theState);
	}
}



// WEBPACK FOOTER //
// ./src/portal/states/user/access-requests/create/create-access-request.controller.js